export enum SettingsP1DataEventObjectsEnum {
  P1_NAVIGATION_ITEM = 'p1_navigation_item',
  P1_VERTICAL_SWITCHER_NAMESPACE = 'p1_vertical_switcher_namespace',
}
